import React, { useState } from 'react';
import { booksAPI } from '../services/api';

function ReturnBookModal({ book, customer, loan, onClose, onSuccess }) {
  // If loan is provided, use its book_condition as default (from when book was borrowed)
  // But prefer current_condition if available (actual current state of the book)
  const getDefaultCondition = () => {
    if (loan && loan.current_condition) {
      console.log('🎯 Using loan.current_condition (current book state):', loan.current_condition);
      return loan.current_condition;
    }
    if (loan && loan.book_condition) {
      console.log('🎯 Using loan.book_condition (borrowed state):', loan.book_condition);
      return loan.book_condition;
    }
    if (book && book.current_condition) {
      console.log('🎯 Using book.current_condition:', book.current_condition);
      return book.current_condition;
    }
    if (book && book.condition) {
      console.log('🎯 Using book.condition:', book.condition);
      return book.condition;
    }
    console.log('🎯 Using default condition: טוב');
    return 'טוב';
  };

  const [bookCondition, setBookCondition] = useState(getDefaultCondition());
  const [returnNotes, setReturnNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  console.log('📋 ReturnBookModal initialized with bookCondition:', bookCondition);

  const handleReturn = async () => {
    try {
      setLoading(true);
      setError('');

      console.log('═══════════════════════════════════════════════════════════');
      console.log('📤 SENDING RETURN BOOK REQUEST');
      console.log('═══════════════════════════════════════════════════════════');
      console.log('👤 Customer identity_id:', customer.identity_id);
      console.log('📖 Book id:', book.current_book_id || book.book_id || book.id);
      console.log('📊 bookCondition state:', bookCondition, 'type:', typeof bookCondition);
      console.log('📝 returnNotes:', returnNotes);
      
      const payload = {
        book_condition: bookCondition,
        return_notes: returnNotes
      };
      console.log('📦 Full payload:', JSON.stringify(payload, null, 2));
      console.log('═══════════════════════════════════════════════════════════');

      const bookId = book.current_book_id || book.book_id || book.id;
      console.log('🔗 Calling booksAPI.return() with book_id:', bookId);
      await booksAPI.return(bookId, payload);

      // Show success message
      alert('הספר הוחזר בהצלחה');
      console.log('✅ Return successful, calling onSuccess()');
      onSuccess();
      console.log('🚪 Closing modal');
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בהחזרת הספר');
      console.error('Error returning book:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2>החזרת ספר</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <p><strong>שם הספר:</strong> {book.book_title || book.book_name}</p>
          <p><strong>שם הלקוח:</strong> {customer.name}</p>
        </div>

        {error && (
          <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '10px', borderRadius: '4px', marginBottom: '15px' }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            מצב הספר:
          </label>
          <select
            value={bookCondition}
            onChange={(e) => {
              console.log('🔄 Select changed! Old value:', bookCondition, 'New value:', e.target.value);
              setBookCondition(e.target.value);
            }}
            disabled={loading}
            style={{
              width: '100%',
              padding: '8px',
              fontSize: '14px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}
          >
            <option value="חדש">חדש</option>
            <option value="טוב">טוב</option>
            <option value="משומש">משומש</option>
            <option value="בלוי">בלוי</option>
          </select>
          <small style={{ color: '#666', marginTop: '5px', display: 'block' }}>
            * אם הספר פגום, תיווספה הערה אוטומטית עם תאריך ההחזרה
          </small>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            הערות (אופציונלי):
          </label>
          <textarea
            value={returnNotes}
            onChange={(e) => setReturnNotes(e.target.value)}
            disabled={loading}
            placeholder="הוסף הערות על תנאי הספר או כל דבר אחר..."
            style={{
              width: '100%',
              padding: '8px',
              fontSize: '14px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              minHeight: '100px',
              fontFamily: 'inherit',
              resize: 'vertical'
            }}
          />
        </div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1
            }}
          >
            ביטול
          </button>
          <button
            onClick={handleReturn}
            disabled={loading}
            style={{
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? 'מעדכן...' : 'החזר ספר'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReturnBookModal;
